var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-circle",style:({ '--dynamic-mask': `url(${_vm.mask})` }),on:{"click":_vm.togglePlay}})
}
var staticRenderFns = []

export { render, staticRenderFns }